<template>
  <div class="vm-feed-small">
    <div class="flex-box">
      <!-- <pic v-if="session_user" :src="session_user.avatar" width="48" height="48" class="wh48 mr16 radius2"/> -->
      <div v-if="cover" class="over-box relative mr16">
        <pic v-if="cover" class="radius2 block" :src="cover" :height="h" :width="w" :style="{height:h + 'px', width:w + 'px'}"></pic>
        <div v-if="is_media" class="over darkbg" :style="{height:h + 'px'}">
          <i class="afd afd-play fs24"></i>
        </div>
      </div>
      <div class="flex-item-1 flex-box flex-direction-column">
        <div class="text-overflow-1 fs14 black-8 fwb mt2">{{post.title}}</div> 
        <div class="text-overflow-1 mt4 black-5 fs12">{{post.content}}</div> 
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "feed-small",
  props: {
    post: {
      default(){
        return {}
      }
    },
  },
  watch:{
  },
  data() {
    return {
      h:48,
      // w:this.post.video_thumb ? 85 : 48,
      // cover: this.post.cover || this.post.audio_thumb || this.post.video_thumb || (this.post.pics.length > 0 ?  this.post.pics[0] : ''),
      // is_media:this.post.video || this.post.audio,
    };
  },
  computed: {
    ...mapState("app", ["browser_size",'session_user']),
    cover(){
      return this.post.cover || this.post.audio_thumb || this.post.video_thumb || (this.post.pics.length > 0 ?  this.post.pics[0] : '')
    },
    w(){
      return this.post.video_thumb ? 85 : 48
    },
    is_media(){
      return this.post.video || this.post.audio
    }
  },
  mounted() {
    // console.log(this.post)
  },
  methods: {
  }
};
</script>

<style lang="stylus" scoped>
.vm-feed-small {
  .wh48{
    width:48px;
    height:48px;
  }
  .over-box{
      border-radius: 2px;
      overflow: hidden;
      &.video-box{
        width:85px;
        height:48px;
      }
  }
  .over{
      left 0
      top 0
      height 100%
      width 100%
      background $black-3
      position absolute
      border-radius: 2px;
  }
  .vm-pic{
      position relative
      height 100%
      display block
  }
 .afd-play{
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)
      color $white
      font-size 32px
  }

}
</style>
